// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1reXn","range":"MonthRangeSwitch_range__3Ks6W","disabled":"MonthRangeSwitch_disabled__3qac0"};